import type { DashboardRouteName } from '@/shared/common/types/dashboardRoutes.type';

/**
 * `HOME` vale `movements` por el nombre histórico de la home en el router; la
 * ruta del listado de movimientos es `MOVEMENTS_ROUTE_NAMES.LIST`
 * (`movements-section`), en `movementsRoutes.constant.ts`.
 */
export const DASHBOARD_ROUTE_NAMES = {
  HOME: 'movements',
  CREATE_COMPENSATION_ACCOUNT: 'create-compensation-account',
} as const;

export const DASHBOARD_ROUTE_PATHS = {
  [DASHBOARD_ROUTE_NAMES.HOME]: '/home',
  [DASHBOARD_ROUTE_NAMES.CREATE_COMPENSATION_ACCOUNT]: '/compensation-account/:walletId',
} as const satisfies Record<DashboardRouteName, string>;
